module.exports = __webpack_public_path__ + "img/baike.d1e18fbf.png";